module.exports = __webpack_public_path__ + "img/banner_out.3350ae43.png";